"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const OptionCard = ({ button, title, message }) => (react_1.default.createElement("div", { className: "rubriq-option card bg-light h-100" },
    react_1.default.createElement("div", { className: "card-body" },
        react_1.default.createElement("h4", { className: "card-title" }, title),
        react_1.default.createElement("div", { className: "card-text" },
            react_1.default.createElement("p", null, message))),
    react_1.default.createElement("div", { className: "card-footer border-top-0 bg-light" },
        react_1.default.createElement("button", { className: "btn btn-primary", type: "button" }, button))));
exports.default = OptionCard;
